<template>
  <modal name="systemshared-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeSystemSharedDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">もうすぐで完了するよ！</p>
        <p style="font-size: 140%;">今作成した履歴書をもとに</p>
        <p style="font-size: 140%;">プロが好条件のエンジニアの勤め先をご紹介します！</p>
        <br>
        <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="true">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/systemshared_yagish_logo.jpeg" style="width:60%">
          </p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a>
        </p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を希望する
          </p>
        </div>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false" style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
            @click="$eventHub.$emit('send-systemshared-consult');">希望する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br />
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div style="text-align: center;">
        <p style="font-size: 90%;">いま、履歴書を作っているから、その間に読んでみて！</p>
        <p style="font-size: 120%; padding-bottom: 20px;">
          未経験からITエンジニアへの転職ハードルを<span
            style="background: linear-gradient(transparent 70%, #0F9934 0%); font-weight: bold;">ぐっと下げました</span>！
          <br>あなたの人生を変える転職エージェント「<span
            style="background: linear-gradient(transparent 70%, #0F9934 0%); font-weight: bold;">就予備｡</span>」
        </p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/syuyobi_yagish_logo.png" style="width: 70%;" alt="就予備。×yagish">
          </p>
        </div>

        <div style="display: flex; justify-content: center; align-items: center;margin: 30px 0;">
          <div style="width: 60%; padding-right: 10px;">
            <ol style="text-align: left; list-style: none;">
              <li style="margin-bottom: 10px;">① エンジニア転職のプロが面接対策から企業選定までサポート</li>
              <li style="margin-bottom: 10px;">② 最短１ヶ月で転職可能</li>
              <li>③ 入社後、優良企業で給料をもらいながら、３ヶ月間のプログラミングスクールに通える</li>
            </ol>
          </div>
          <div style="width: 40%;">
            <img src="/static/renew_img/syuyobi_male.png" alt="スクールで学ぶ男性" style="width: 100%; border-radius: 15px;">
          </div>
        </div>

        <div style="border: 5px solid #0F9934; text-align: center; border-radius: 10px; padding: 20px;">
          <p>人数限定の説明会を<br>yagish紹介のみで開放しているから、<br>
            まずは気軽に参加してみよう！</p>
          <!--日時選択-->
          <el-select v-model="selWebinarDate" autosize placeholder="日程を選択してください">
            <el-option v-for="item in webinarOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <br>
          <a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank"
            style="text-align: center; font-size: 80%; margin: 5px 0;">個人情報保護方針</a>
          <br>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%; margin: 15px 0 10px;"
            @click="$eventHub.$emit('send-systemshared23-consult');">WEB無料説明会に参加する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <p style="font-size: 70%;">※当日の詳細やプログラミングスクールの内容は、<br>
            後ほど担当者からメールでご連絡いたしますので、<br>
            お気軽に参加してみてください！
          </p>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 3">
      <div style="text-align: center;">
        <p style="font-size: 90%;">いま、履歴書を作っているから、その間に読んでみて！</p>
        <p style="font-size: 120%; padding-bottom: 20px;">
          未経験からITエンジニアへの転職ハードルを<span
            style="background: linear-gradient(transparent 70%, #E3165C 0%); font-weight: bold;">ぐっと下げました</span>！
          <br>あなたの人生を変える転職エージェント「<span
            style="background: linear-gradient(transparent 70%, #E3165C 0%); font-weight: bold;">就予備｡</span>」
        </p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/syuyobi_yagish_logo.png" style="width: 70%;" alt="就予備。×yagish">
          </p>
        </div>

        <div style="display: flex; justify-content: center; align-items: center;margin: 30px 0;">
          <div style="width: 60%; padding-right: 10px;">
            <ol style="text-align: left; list-style: none;">
              <li style="margin-bottom: 10px;">① エンジニア転職のプロが面接対策から企業選定までサポート</li>
              <li style="margin-bottom: 10px;">② 最短１ヶ月で転職可能</li>
              <li>③ 入社後、優良企業で給料をもらいながら、３ヶ月間のプログラミングスクールに通える</li>
              <!-- <li style="margin-bottom: 10px;">① ひとりひとりに合わせた<br>IT業界の<span style="background:linear-gradient(transparent 70%, #E3165C 0%);">転職サポート</span>が受けられる！</li>
                    <li style="margin-bottom: 10px;">② 内定後、<span style="background:linear-gradient(transparent 70%, #E3165C 0%);">国の補助金</span>を受けながら<br>プログラミング研修を受けられる！</li>
                    <li>③ <span style="background:linear-gradient(transparent 70%, #E3165C 0%);">未経験・知識なし</span>からでもIT業界で<br>活躍できる！</li> -->
            </ol>
          </div>
          <div style="width: 40%;">
            <img src="/static/renew_img/syuyobi_female.png" alt="スクールで学ぶ女性" style="width: 100%; border-radius: 15px;">
          </div>
        </div>

        <div style="border: 5px solid #E3165C; text-align: center; border-radius: 10px; padding: 20px;">
          <p>人数限定の説明会を<br>yagish紹介のみで開放しているから、<br>
            まずは気軽に参加してみよう！</p>
          <!--日時選択-->
          <el-select v-model="selWebinarDate" autosize placeholder="日程を選択してください">
            <el-option v-for="item in webinarOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <br>
          <a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank"
            style="text-align: center; font-size: 80%; margin: 5px 0;">個人情報保護方針</a>
          <br>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%; margin: 15px 0 10px;"
            @click="$eventHub.$emit('send-systemshared23-consult');">WEB無料説明会に参加する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <p style="font-size: 70%;">※当日の詳細やプログラミングスクールの内容は、<br>
            後ほど担当者からメールでご連絡いたしますので、<br>
            お気軽に参加してみてください！
          </p>
        </div>
      </div>

    </div>
    <div class="setting" v-else-if="permissionType == 42">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">今作成した履歴書をもとに</p>
        <p style="font-size: 140%;">プロが好条件の勤め先をご紹介します！</p>
        <br>
        <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="true">
          <p style="font-size: 140%;">
            <img src="/static/renew2_img/systemshared_yagish_logo_20230601.jpeg" style="width:60%">
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
          <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a>
        </p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を希望する
          </p>
        </div>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false" style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
            @click="$eventHub.$emit('send-systemshared-consult');">希望する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br />
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 4">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/system02_yagish_logo20230616.png" alt="システムシェアードとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a></p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-systemshared-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 5">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/system02_yagish_logo20230616.png" alt="システムシェアードとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a></p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-systemshared-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 6">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/system02_yagish_logo20230616.png" alt="システムシェアードとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a></p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-systemshared-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 8">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/system02_yagish_logo20230616.png" alt="システムシェアードとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a></p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-systemshared-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 9">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/system02_yagish_logo20230616.png" alt="システムシェアードとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a></p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-systemshared-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 10">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/system02_yagish_logo20230616.png" alt="システムシェアードとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)システムシェアードの<a href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">利用規約</a>、<a
            href="https://www.3sss.co.jp/privacy-policy/index.html" target="_blank">個人情報保護方針</a></p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isSystemSharedSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-systemshared-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSystemSharedSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeSystemSharedDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSystemSharedSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      fullscreenLoading: false,
      selWebinarDate: '',
      clientId: 'systemshared_mail',
      username: '',
      baite_title: 'バイト',
      isAgree: true,
      webinarOptions: []
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    addDate: function (date, flag) {
      if (flag == 1) {
        const targetDate = new Date(date)
        targetDate.setDate(date.getDate() + 5)
        return targetDate
      } else if (flag == 2) {
        const targetDate = new Date(date)
        targetDate.setDate(date.getDate() + 2)
        return targetDate
      }
    },
    openSystemSharedDialog: function (id, html, permissionType, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('systemshared-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      // 毎週木曜の14：00～14:40と火曜の19;00～19;40
      const limitDate = new Date(2023, (2 - 1), 10, 23, 59)
      const now = new Date()
      const dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土']
      this.webinarOptions = []
      let targetDate = new Date(now)
      let startint = 1
      let diff = 0
      if (now.getDay() < 2) {
        startint = 2
        diff = 2 - now.getDay()
      } else if (now.getDay() >= 2 && now.getDay() < 4) {
        startint = 1
        diff = 4 - now.getDay()
      } else {
        startint = 2
        diff = 9 - now.getDay()
      }
      targetDate.setDate(now.getDate() + diff)
      let dateStr = (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日(' + dayOfWeekStr[targetDate.getDay()] + ')'
      if (targetDate.getDay() == 4) {
        dateStr = dateStr + ' 14:00～14:40'
      } else if (targetDate.getDay() == 2) {
        dateStr = dateStr + ' 19:00～19:40'
      }
      // this.webinarOptions.push({
      //   value: dateStr,
      //   label: dateStr
      // })
      while (targetDate < limitDate) {
        targetDate = this.addDate(targetDate, startint)
        let dateStr = (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日(' + dayOfWeekStr[targetDate.getDay()] + ')'
        if (targetDate.getDay() == 4) {
          dateStr = dateStr + ' 14:00～14:40'
        } else if (targetDate.getDay() == 2) {
          dateStr = dateStr + ' 19:00～19:40'
        }
        // this.webinarOptions.push({
        //   value: dateStr,
        //   label: dateStr
        // })
        if (startint == 1) {
          startint = 2
        } else {
          startint = 1
        }
      }
      targetDate = new Date(2023, (2 - 1), 15, 23, 59)
      if (now < targetDate) {
        dateStr = (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日(' + dayOfWeekStr[targetDate.getDay()] + ')' + ' 14:00～14:40'
        this.webinarOptions.push({
          value: dateStr,
          label: dateStr
        })
      }
      targetDate = new Date(2023, (2 - 1), 20, 23, 59)
      if (now < targetDate) {
        dateStr = (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日(' + dayOfWeekStr[targetDate.getDay()] + ')' + ' 14:00～14:40'
        this.webinarOptions.push({
          value: dateStr,
          label: dateStr
        })
      }
      targetDate = new Date(2023, (2 - 1), 22, 23, 59)
      if (now < targetDate) {
        dateStr = (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日(' + dayOfWeekStr[targetDate.getDay()] + ')' + ' 14:00～14:40'
        this.webinarOptions.push({
          value: dateStr,
          label: dateStr
        })
      }
      targetDate = new Date(2023, (2 - 1), 28, 23, 59)
      if (now < targetDate) {
        dateStr = (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日(' + dayOfWeekStr[targetDate.getDay()] + ')' + ' 19:00～19:40'
        this.webinarOptions.push({
          value: dateStr,
          label: dateStr
        })
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'systemshared_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeSystemSharedDialog: function () {
      this.$modal.hide('systemshared-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isSystemSharedSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendSystemSharedConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'systemshared_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendSystemShared, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSystemSharedSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendSystemSharedConsult23: async function () {
      if (!this.selWebinarDate) {
        this.$message({
          message: '参加できる日程を選択してください。',
          type: 'error'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'systemshared_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('webinar_date', this.selWebinarDate)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendSystemShared23, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSystemSharedSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-systemshared-consult', this.sendSystemSharedConsult)
    this.$eventHub.$on('send-systemshared23-consult', this.sendSystemSharedConsult23)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openSystemSharedDialog = wrapMittPopupHandler(this, 'openSystemSharedDialog')
    this.$emitter.on('open-systemshared-dialog', this._mittGVPopup_openSystemSharedDialog)
    this.$eventHub.$on('popstate', this.closeSystemSharedDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-systemshared-consult', this.sendSystemSharedConsult)
    this.$eventHub.$off('send-systemshared23-consult', this.sendSystemSharedConsult23)
    this.$emitter.off('open-systemshared-dialog', this._mittGVPopup_openSystemSharedDialog)
    this.$eventHub.$off('popstate', this.closeSystemSharedDialog)
  }
}
</script>
